import { formFor, FormForType } from "fw-model";
import { GridColumn } from "models/grid-column";

export type GridColumnForm = FormForType<GridColumn>;

export const gridColumnFormCreator = formFor(GridColumn, s => {
  s.requiredField(col => col.Label, "Label");
});
